import { useEffect, useEffectEvent, useState } from 'react';

import * as EventEmitter from '@/utils/event-emitter';

const useIsModalOpen = (id: string): boolean => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onModalStatusChange = useEffectEvent((isOpen: boolean) => {
    setIsModalOpen(isOpen);
  });

  useEffect(() => {
    const openModalId = `${id}::modal-status`;
    const handleModalStatusChange = (data: boolean) => {
      onModalStatusChange(!!data);
    };
    EventEmitter.addEventListener(openModalId, handleModalStatusChange);

    return () => EventEmitter.removeEventListener(openModalId, handleModalStatusChange);
  }, [id]);

  return isModalOpen;
};

export default useIsModalOpen;
